import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import QuizIcon from "@mui/icons-material/Quiz";
import StyleIcon from "@mui/icons-material/Style";
import { createUseStyles } from "react-jss";

export type MobileTab = "study" | "test" | "more";

const TABS: { id: MobileTab; label: string; Icon: typeof StyleIcon }[] = [
  { id: "study", label: "Study", Icon: StyleIcon },
  { id: "test", label: "Test", Icon: QuizIcon },
  { id: "more", label: "More", Icon: InfoOutlinedIcon }
];

const useStyles = createUseStyles({
  bar: {
    flexShrink: 0,
    position: "sticky",
    bottom: 0,
    zIndex: 20,
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    boxSizing: "border-box",
    height: "calc(56px + env(safe-area-inset-bottom, 0px))",
    paddingBottom: "env(safe-area-inset-bottom, 0px)",
    backgroundColor: "#1e2229",
    borderTop: "1px solid #404754"
  },
  tab: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 2,
    minHeight: 56,
    padding: "6px 4px",
    border: "none",
    background: "transparent",
    color: "#94a3b8",
    cursor: "pointer"
  },
  tabActive: {
    color: "#5DCAA5"
  },
  label: {
    fontSize: 11,
    fontWeight: 600,
    lineHeight: 1.2
  }
});

const MobileTabBar = ({
  active,
  onChange
}: {
  active: MobileTab;
  onChange: (tab: MobileTab) => void;
}) => {
  const classes = useStyles();

  return (
    <nav className={classes.bar} aria-label="App sections">
      {TABS.map(({ id, label, Icon }) => {
        const isActive = active === id;
        return (
          <button
            key={id}
            type="button"
            className={`${classes.tab} ${isActive ? classes.tabActive : ""}`}
            aria-current={isActive ? "page" : undefined}
            aria-label={label}
            onClick={() => onChange(id)}>
            <Icon fontSize="small" />
            <span className={classes.label}>{label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default MobileTabBar;
